module.exports = __webpack_public_path__ + "img/ranking.98a84dbd.svg";